// src/components/Footer.js
import React from 'react';
import { Typography, Link, Box, useTheme, Container } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';

const fontFamily = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif";

const colors = {
    textSecondary: '#475569',
    textTertiary: '#94a3b8',
    accent: '#3b82f6',
};

function Footer() {
    const year = new Date().getFullYear();
    const theme = useTheme();

    return (
        <Box
            component="footer"
            sx={{
                mt: 'auto',
                py: 2,
                px: 3,
                backgroundColor: 'transparent',
            }}
        >
            <Container maxWidth="xl">
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 2,
                        [theme.breakpoints.down('md')]: {
                            flexDirection: 'column',
                            alignItems: 'center',
                        },
                    }}
                >
                    {/* Copyright */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography
                            sx={{
                                fontFamily,
                                color: colors.textTertiary,
                                fontSize: '0.8rem',
                            }}
                        >
                            © {year}
                        </Typography>
                        <Link
                            href="https://klonit.ai"
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="none"
                            sx={{
                                fontFamily,
                                color: colors.accent,
                                fontWeight: 600,
                                fontSize: '0.8rem',
                                '&:hover': { color: '#2563eb' },
                            }}
                        >
                            KlonIT
                        </Link>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <BoltIcon sx={{ fontSize: 12, color: colors.accent }} />
                            <Typography sx={{ fontFamily, color: colors.textTertiary, fontSize: '0.75rem' }}>
                                Clone · Scale · Grow
                            </Typography>
                        </Box>
                    </Box>

                    {/* Links */}
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2.5,
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {[
                            { label: 'Support', href: 'https://klonit.ai/support' },
                            { label: 'Privacy', href: 'https://klonit.ai/privacy-policy' },
                            { label: 'Terms', href: 'https://klonit.ai/terms-of-use' },
                            { label: 'Docs', href: 'https://docs.klonit.ai/', external: true },
                        ].map((link, index) => (
                            <Link
                                key={index}
                                href={link.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="none"
                                sx={{
                                    fontFamily,
                                    color: colors.textTertiary,
                                    fontSize: '0.8rem',
                                    fontWeight: 500,
                                    transition: 'color 0.2s ease',
                                    '&:hover': { color: colors.accent },
                                }}
                            >
                                {link.label}
                            </Link>
                        ))}
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;
